import TreeNode from './TreeNode'
function Tree({ treeData, folderClicked, active }) {
    return (
      <ul style={{ paddingLeft: 20 }}>
        {treeData.sort((a, b) => a.document_name.localeCompare(b.document_name)).map((node) => (
          <TreeNode node={node} key={node.key} clickedFolder={folderClicked} activeFolder={active} />
        ))}
      </ul>
    );
  }

export default Tree